export const FORECAST_CONFIG_TARGET_VALUES = [
  'rough_in',
  'vendor',
  'market',
] as const;

export type ForecastConfigTarget = (typeof FORECAST_CONFIG_TARGET_VALUES)[number];
